export default __webpack_public_path__ + "media/images/file_types/pdf-74ea41a5c4ae9d09f6aea42ca65162b7.svg";